<template>
    <div class="commentComposer">
        <div class="commentComposer__inner">
            <div class="commentComposer__avatar">
                <div>
                    <avatar-image :url="user.avatar" />
                </div>
            </div>
            <!--/.commentComposer__avatar-->
            <div class="commentComposer__input">
                <editor-content :editor="editor" />
            </div>
            <!--/.commentComposer__input-->
        </div>
        <!--/.commentComposer__inner-->
        <div
            v-if="hasFocus || hasEnteredText"
            class="commentComposer__actions"
        >
            <div class="commentComposer__submit">
                <button
                    class="button -blue"
                    @click="handleCommentSubmit"
                >
                    {{ submitText }}
                </button>
            </div>
            <!--/.commentComposer__submit-->
        </div>
        <!--/.commentComposer__actions-->
    </div>
    <!--/.commentComposer-->
</template>
<script>
import { EditorContent, Editor } from 'tiptap';
import { Placeholder } from 'tiptap-extensions';
import { mapActions, mapState } from 'vuex';
import EventBus from '../../EventBus';
import AvatarImage from '../AvatarImage.vue';

export default {
    name: 'CommentComposer',
    components: {
        AvatarImage,
        EditorContent,
    },
    props: {
        parentId: {
            type: Number,
            default: null,
        },
        placeholder: {
            type: String,
            default: '',
        },
        submitText: {
            type: String,
            default: 'Comment',
        },
        content: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            editor: new Editor({
                onFocus: () => {
                    this.hasFocus = true;
                },
                onBlur: () => {
                    this.hasFocus = false;
                },
                content: this.content || '',
                extensions: [
                    new Placeholder({
                        emptyEditorClass: 'is-editor-empty',
                        emptyNodeClass: 'is-empty',
                        emptyNodeText: this.placeholder,
                        showOnlyWhenEditable: true,
                        showOnlyCurrent: true,
                    }),
                ],
            }),
            hasFocus: false,
        };
    },
    computed: {
        ...mapState(['user']),
        ...mapState('comments', ['article']),
        hasEnteredText() {
            return this.editor.getHTML() !== '<p></p>';
        },
    },
    methods: {
        ...mapActions('comments', ['addComment', 'addChildComment']),
        broadcastCommentCount(count) {
            EventBus.$emit('update-comment-count', count);
        },
        handleCommentSubmit() {
            if (!this.parentId) {
                axios.post('/api/comments', {
                    commentable_type: 'Article',
                    commentable_id: this.article.id,
                    user_id: this.user.id,
                    body: this.editor.getHTML(),
                }).then((response) => {
                    this.addComment(response.data.comment);
                    this.broadcastCommentCount(response.data.commentCount);
                    this.editor.clearContent();
                });
            } else {
                axios.post('/api/comments', {
                    commentable_type: 'Article',
                    commentable_id: this.article.id,
                    parent_id: this.parentId,
                    user_id: this.user.id,
                    body: this.editor.getHTML(),
                }).then((response) => {
                    this.addChildComment({
                        comment: response.data.comment,
                        parentId: this.parentId,
                    });
                    this.editor.clearContent();
                    this.$emit('commentAdded');
                    this.broadcastCommentCount(response.data.commentCount);
                });
            }
        },
    },
};
</script>

<style lang="scss">
    .commentComposer__input p.is-editor-empty:first-child::before {
        content: attr(data-empty-text);
        float: left;
        padding-left: 0.4rem;
        color: hsl(0, 1%, 75%);
        pointer-events: none;
        height: 0;
        font-style: italic;
        font-size: 1.8rem;
    }

    .ProseMirror:focus {
        outline: none;
        border: none;
    }
</style>
